<template>
	<home-tile
		:button-title="'Update Donation Card'"
		@click="showCard"
		v-if="determineExpTime <= 2"
		color="danger"
		v-bind:style="{ paddingTop: '50px' }"
	>
		<h3 class="tile-header" style="margin-top: -35px">
			Your donation card needs to be updated.
		</h3>
		<span v-if="new Date(cardExp) > new Date()" class="tile-text-small"
			>Your card will expire on {{ this.expirationDate }}</span
		>
		<span v-else class="tile-text-small"
			>Your card expired on {{ this.expirationDate }}</span
		>
	</home-tile>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import HomeTile from './HomeTile'

export default {
	name: 'expired-card-tile',
	components: { HomeTile },
	computed: {
		...mapState({
			cardBrand: ({ me }) => me.current.card_brand,
			cardLast4: ({ me }) => me.current.card_last_four,
			cardExp: ({ me }) => me.current.card_exp
		}),
		expirationDate() {
			return this.$moment.utc(this.cardExp).format('M/D/YYYY')
		},
		determineExpTime() {
			if (!this.cardExp) {
				return Number.MAX_SAFE_INTEGER
			}
			var months
			const d2 = new Date(this.cardExp)
			const d1 = new Date()

			months = (d2.getFullYear() - d1.getFullYear()) * 12
			months -= d1.getMonth()
			months += d2.getMonth()
			return months <= 0 ? 0 : months
		}
	},
	methods: {
		...mapActions(['getHome']),
		showCard() {
			this.navigate({ name: 'card' }, 'forward')
		}
	},
	mounted() {}
}
</script>

<style lang="scss"></style>
